import graphql__f935e157dddfc80631d2 from "./__generated__/SuggestionCardActions_contribution.graphql.js";import { useEffect } from "react";
import { graphql, useFragment } from "react-relay";
import { defineMessages } from "react-intl";
import classNames from "classnames";

import Button from "../Buttons/Button";
import VoteButtons from "../Votable/VoteButtons";
import InlineCommentForm from "./InlineCommentForm";
import useInlineComment from "./useInlineComment";
import { useFormatMessage } from "../Intl/Context";
import { isUnauthorized } from "../Utils/authorizations";

const SuggestionCardActions = props => {
  const contribution = useFragment(
    SuggestionCardActions_contribution,
    props.contribution
  );

  const { onCommentFormOpenChange } = props;

  const commentsSubmissionAuthorized = !isUnauthorized(
    contribution.authorizations.commentsSubmissionAuthorized
  );

  const {
    commentFormRef,
    isFormOpen,
    isEditing,
    isSubmitting,
    publishedComment,
    handleOpenForm,
    handleCloseForm,
    handleEdit,
    handleCreate,
    handleUpdate,
    handleDelete
  } = useInlineComment({ commentable: contribution });

  // Notify the parent so it can hide the navigation buttons while the comment
  // form is open.
  useEffect(() => {
    if (onCommentFormOpenChange) onCommentFormOpenChange(isFormOpen);
  }, [isFormOpen, onCommentFormOpenChange]);

  const t = useFormatMessage();
  const addCommentLabel = t(intlMessages.addComment);
  const closeCommentLabel = t(intlMessages.closeComment);
  const publishLabel = t(intlMessages.publish);
  const saveLabel = t(intlMessages.save);

  // Show the comment trigger when there is no published comment and the
  // form is closed. Show the cancel trigger when the create form is open.
  // When editing, the trigger is hidden — cancel lives inside the edit form.
  const showCommentTrigger =
    commentsSubmissionAuthorized && (isFormOpen ? !isEditing : !publishedComment);

  const commentButtonLabel = isFormOpen ? closeCommentLabel : addCommentLabel;
  const commentButtonClassName = classNames("btn", {
    "btn-primary": !isFormOpen,
    "btn-primary-inverse": isFormOpen,
    border: isFormOpen,
    "btn-default": !isFormOpen
  });
  const commentButtonIconClassName = isFormOpen ? "fa fa-times" : "fa fa-comment";

  const submitHandler = isEditing ? handleUpdate : handleCreate;
  const submitLabel = isEditing ? saveLabel : publishLabel;

  return (
    <div className="padding-xs">
      <div className="suggestion-card-actions">
        <VoteButtons votable={contribution} size="sm" className="vote-buttons-inline" />

        {showCommentTrigger && (
          <Button
            type="button"
            className={commentButtonClassName}
            onClick={isFormOpen ? handleCloseForm : handleOpenForm}
            label={commentButtonLabel}
            iconClassName={commentButtonIconClassName}
            iconPosition="after"
          />
        )}
      </div>

      <InlineCommentForm
        isFormOpen={isFormOpen}
        isEditing={isEditing}
        isSubmitting={isSubmitting}
        publishedComment={publishedComment}
        submitLabel={submitLabel}
        commentFormRef={commentFormRef}
        onSubmit={submitHandler}
        onCancel={handleCloseForm}
        onEdit={handleEdit}
        onDelete={handleDelete}
      />
    </div>
  );
};

const SuggestionCardActions_contribution = graphql__f935e157dddfc80631d2;

export default SuggestionCardActions;

const intlMessages = defineMessages({
  addComment: {
    id: "inlineCommentInput.addComment",
    defaultMessage: "Commenter"
  },
  closeComment: {
    id: "inlineCommentInput.closeComment",
    defaultMessage: "Annuler"
  },
  publish: {
    id: "inlineCommentInput.publish",
    defaultMessage: "Publier"
  },
  save: {
    id: "inlineCommentInput.save",
    defaultMessage: "Enregistrer"
  }
});
